import Http from "./http";

export const getReleaseDocListAPI = (data, options) => {
    return Http.post("admin/getDocumentList", data, options);
};

export const updateReleaseDocumentStatusAPI = (data, options) => {
    return Http.post("admin/createOrUpdateDocument", data, options);
};
